import type { HttpError } from '@refinedev/core'
import { useList } from '@refinedev/core'
import type { GameOption } from '@sirius/contracts/admin'
import { useMemo } from 'react'
import type { GameNames } from './gameNames'

/**
 * Every game a cabinet can offer (`gameOptions`, one query for the whole
 * page), sorted by name (the API's default sort), plus their names by id.
 */
export function useGameOptions() {
  const { result, query } = useList<GameOption, HttpError>({
    resource: 'gameOptions',
    pagination: { mode: 'off' },
  })
  const options = result.data
  const names = useMemo<GameNames>(
    () => ({
      byId: new Map(options.map(({ id, name }) => [id, name])),
      isLoading: query.isLoading,
      isError: query.isError,
    }),
    [options, query.isLoading, query.isError],
  )
  return { options, names, query }
}
